import { useWorkspace } from '@/features/workspaces/hooks';
import { DonutChartItem, DonutChartLegend } from '@/lib';
import { useGetWorkspaceMetricsQuery } from '@/services/endpoints/metrics';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { HomeDataSectionChart } from '../../../common';
import { HOME_DESTINATIONS_CHART_GROUPS, HomeDestinationsChart } from './HomeDestinationsChart';
import { DestinationChartItem } from './types';

export const HomeDestinationsChartWidget: FC = () => {
  const { t } = useTranslation();
  const workspace = useWorkspace();
  const { data: metrics } = useGetWorkspaceMetricsQuery({ workspaceId: workspace.id });

  const chartData = useMemo<(DestinationChartItem & DonutChartItem)[]>(
    () =>
      Object.entries(HOME_DESTINATIONS_CHART_GROUPS).map(([key, value]) => ({
        name: t(`home:${key as keyof typeof HOME_DESTINATIONS_CHART_GROUPS}`),
        value: value.statuses.reduce((acc, status) => acc + (metrics?.distributionChannels[status] || 0), 0),
        fill: value.color,
        color: value.color,
      })),
    [metrics?.distributionChannels]
  );

  const legend = useMemo(() => Array.from(chartData).reverse(), [chartData]);

  return (
    <HomeDataSectionChart title='home.destinationsChartTitle'>
      <div className='flex items-center gap-4'>
        <HomeDestinationsChart data={chartData} activeTotal={metrics?.distributionChannels['ACTIVE']} className='size-[12.5rem]' />
        <DonutChartLegend data={legend} />
      </div>
    </HomeDataSectionChart>
  );
};
